import { useContext, useEffect, useState, useCallback } from "react";
import { AuthContext } from "../../context/AuthProvider";
import { EditorContext } from "../../editor/context/EditorContext/EditorProvider";

/**
 * Shared editor-access logic for the multitrack-editor open button.
 *
 * Returns the bits any UI surface needs to render an "open in editor"
 * affordance with consistent gating + tooltip text + click behavior.
 */
const useEditorAccess = track => {
  const auth = useContext(AuthContext);
  const editor = useContext(EditorContext);

  const [canAccess, setCanAccess] = useState(false);

  useEffect(() => {
    setCanAccess(auth.canAccessTrackEditor(track).granted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth, track.id]);

  const onClick = useCallback(() => {
    if (track.editorOpenable && track.stem.length > 0) {
      editor.requestTrackOpen(track, true);
    }
  }, [editor, track]);

  const tooltipText = canAccess
    ? "Open in Multitrack Editor"
    : track.editorOpenable
    ? "Subscribe to access the editor"
    : "Track not available";

  return { canAccess, onClick, tooltipText };
};

export default useEditorAccess;
